<div #contentPanel class="content-panel">
  <app-search-bar id="search-documents-filter" [currentPage]="currentPage" [hidden]="entityId" />
  <div class="content">
    <router-outlet></router-outlet>
  </div>
</div>
<app-filter class="filter-panel" [hidden]="entityId"
            [inDocumentView]="!!entityId"
            [currentPage]="currentPage"
            [territoryUid]="territoryUid"
            [relativeTo]="contentPanel"
>
</app-filter>
@if (smartSearchService.modalOpen(); as open) {
  <app-smart-search-modal
    [isOpen]="open"
    [searchConfig]="smartSearchService.context()"
    (closeModal)="smartSearchService.modalOpen.set(false)"
  />
}
